import React, { useEffect, useState } from "react";
import ContributionSkyline from "./ContributionSkyline";
import { useLang } from "../i18n";

const PALETTE = {
  light: ["#d7e8b4", "#8fb83a", "#3d6b14", "#1b4d0e"],
  dark: ["#2a3818", "#5a7a1c", "#a4cc45", "#d6f25c"],
};

function Activity() {
  const { lang, t } = useLang();
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    fetch("https://github-contributions-api.jogruber.de/v4/ali8600?y=last", { signal: controller.signal })
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.json();
      })
      .then((body) => {
        const days = Array.isArray(body.contributions) ? body.contributions : [];
        setData(days.map((day) => ({ date: day.date, count: day.count })));
      })
      .catch((error) => {
        if (error.name === "AbortError") return;
        setFailed(true);
      });
    return () => controller.abort();
  }, []);

  return (
    <section id="activity" className="mt-20">
      <div className="section-label">
        <h2>{t.activity.heading}</h2>
        <a href="https://github.com/ali8600" target="_blank" rel="noopener noreferrer">github ↗</a>
      </div>
      {data ? (
        <ContributionSkyline
          data={data}
          locale={lang === "de" ? "de-DE" : "en-US"}
          palette={PALETTE}
          unit={t.activity.unit}
          unitPlural={t.activity.unitPlural}
          defaultView="3d"
        />
      ) : (
        <p className="skyline-pending">{failed ? t.activity.unavailable : ""}</p>
      )}
    </section>
  );
}

export default Activity;
